export default {
  logout: 'Log out',
};
